<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="5"></Header>
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">公司信息管理</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-office-building"></i></div>
      <div class="gerenxinxi">公司信息管理</div>
    </div>
    <div class="head01">
      <Header :activeIndex="5" v-if="!isMobile"></Header>
      <div class="head02">
        <div class="neirong">
          <div>
            <div class="jianju">
              <span class="span">单位名称：</span><el-input class="kuandu" v-model="companyName" placeholder="单位名称"
                :disabled="isDisabled"></el-input>
            </div>
            <div class="jianju">
              <span class="span">成立时间：</span><el-date-picker class="kuandu" v-model="foundingDate" type="date"
                placeholder="选择日期" :disabled="isDisabled">
              </el-date-picker>
            </div>
            <div class="jianju">
              <span class="span">所属行业：</span><el-select v-model="industryId" placeholder="请选择所属行业" :disabled="isDisabled"
                filterable class="kuandu">
                <el-option v-for="industryItem in industries" :key="industryItem.industryId"
                  :label="industryItem.industryName" :value="industryItem.industryId" />
              </el-select>
            </div>
            <div class="jianju">
              <span class="span">所在城市：</span><el-cascader v-model="city" :options="rcdistrict" class="kuandu"
                :disabled="isDisabled" :props="{ checkStrictly: true }" @change="handleChangerc"></el-cascader>
            </div>
            <div class="jianju1">
              <div style="display:flex;align-items: center;">
                <span class="span1">工作地点：</span>
                <div style="display:flex;flex-direction: column;">
                  <div v-for="(workplace, index) in workplaces" :key="index">
                    <el-input class="kuandu" v-model="workplaces[index]" placeholder="请输入工作地点" clearable
                      :disabled="isDisabled"></el-input>
                    <el-button type="danger" icon="el-icon-delete" circle @click="removeWorkplace(index)"
                      v-if="workplaces.length > 1" :disabled="isDisabled"></el-button>
                  </div>
                </div>
              </div>
              <div class="jianju">
                <el-button type="primary" @click="addWorkplace" :disabled="isDisabled">新增工作地点</el-button>
              </div>
            </div>
            <div class="jianju">
              <span class="span">公司规模：</span><el-select class="kuandu" v-model="companySize" placeholder="请选择"
                :disabled="isDisabled">
                <el-option v-for="item in companySizes" :key="item.companySize" :label="item.label"
                  :value="item.companySize">
                </el-option>
              </el-select>
            </div>
            <div class="jianju">
              <span class="span">联系电话：</span><el-input class="kuandu" v-model="phoneNumber" placeholder="手机号"
                :disabled="true"></el-input>
            </div>
            <div class="jianju">
              <span class="span">联系邮箱：</span><el-input class="kuandu" v-model="email" placeholder="邮箱"
                :disabled="isDisabled"></el-input>
            </div>
            <div style="display:flex;flex-direction: column;text-align: left;" v-if="!isDisabled">
              <div class="kuanjia">
                <div class="save" @click="save">保存信息</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isDisabled" class="xiugai">
          <div class="qvxiao" @click="update">修改</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './qiyeHeader.vue'
import Footer from './Footer.vue'
export default {
  name: 'corpinfo',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      companyName: '',
      foundingDate: '',
      companySizes: [{
        companySize: '1',
        label: '100人以下'
      }, {
        companySize: '2',
        label: '100-500人'
      }, {
        companySize: '3',
        label: '500人以上'
      }],
      companySize: '',
      industryId: '',
      city: '',
      workplaces: [''],
      // workplace: '',
      isDisabled: false,
      qiyeId: sessionStorage.getItem("qiyeId"),
      id: null,
      phoneNumber: '',
      email: '',
      industries: [],
      BASE_URL: 'https://zhiyedashi.com/info',
      BASE_URL1: 'https://zhiyedashi.com/job',
      // BASE_URL: 'http://192.168.2.8:8206',
      // BASE_URL1: 'http://192.168.2.8:8204',
      rcdistrict: JSON.parse(localStorage.getItem("rc")),
      isMobile: false
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.qiyeId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.selectindustry()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleChangerc(selectedData) {
      // selectedData 是当前选中节点的完整数据（包括所有层级）
      const lastNode = selectedData[selectedData.length - 1]; // 获取最后一级节点

      if (!lastNode.children || lastNode.children.length === 0) {
        this.city = lastNode
        // 这里可以处理最后一级的数据，比如提交到后端
      }
    },
    selectindustry() {
      if (localStorage.getItem("industries")) {
        this.industries = JSON.parse(localStorage.getItem("industries"))
        this.selectByqiyeId()
      } else {
        // 查询所属行业
        fetch(`${this.BASE_URL1}/admin/industry/selectIndustry`, {
          method: 'POST'
        })
          .then(res => res.json())
          .then(data => {
            // console.log("所在行业成功", data);
            localStorage.setItem("industries", JSON.stringify(data.data))
            this.industries = data.data
            this.selectByqiyeId()
          })
          .catch(error => {
            console.error("查询失败，原因是", error);
          });
      }
    },
    update() {
      this.isDisabled = false
    },
    addWorkplace() {
      this.workplaces.push(''); // 关键：新增空字符串
    },
    removeWorkplace(index) {
      this.workplaces.splice(index, 1);
    },
    save() {
      this.workplace = JSON.stringify(this.workplaces);
      if (this.companyName === '' || this.foundingDate === '' || this.industryId === '' || this.city === '' || this.workplace === '' || this.companySize === '' || this.phoneNumber === '' || this.email === '') {
        alert("数据不能为空")
      } else {
        let companyInfo = {
          id: this.id,
          qiyeId: this.qiyeId,
          companyName: this.companyName,
          foundingDate: this.foundingDate,
          phoneNumber: this.phoneNumber,
          email: this.email,
          industryId: this.industryId,
          city: this.city,
          workplace: this.workplace,
          companySize: this.companySize
        }
        fetch(`${this.BASE_URL}/admin/company/saveCompanyInfo`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(companyInfo)
        })
          .then(res => res.json())
          .then(data => {
            if (data.code === 200) {
              this.isDisabled = true
              this.selectByqiyeId()
              alert("保存成功")
            } else {
              alert("网络有波动，请稍后重试")
            }
          })
          .catch(error => {
            console.error("保存失败，原因是", error);
          })
      }
    },
    selectByqiyeId() {
      // 根据qiyeId 去查询所有信息
      fetch(`${this.BASE_URL}/admin/company/selectByUserId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `qiyeId=${this.qiyeId}`
      })
        .then(res => res.json())
        .then(data => {
          if (data.data === '企业信息不存在') {
            this.isDisabled = false
          } else {
            // console.log("企业信息", data.data.foundingDate);
            let comp = data.data
            if (data.data.foundingDate === null) {
              this.phoneNumber = comp.phoneNumber
              this.isDisabled = false
            } else {
              this.city = comp.city
              this.companyName = comp.companyName
              this.companySize = comp.companySize
              this.email = comp.email
              this.phoneNumber = comp.phoneNumber
              this.foundingDate = comp.foundingDate
              this.id = comp.id
              this.industryId = comp.industryId
              this.workplaces = JSON.parse(comp.workplace)
              this.isDisabled = true
            }
          }
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
  }
}
</script>

<style>
.el-input.is-disabled .el-input__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}
</style>

<style scoped>
.kuandu {
  width: 350px;
}

.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  gap: 100px;
}

.head02 {
  display: flex;
  gap: 100px;
}

.neirong {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-left: 100px;
}

.jianju {
  margin-top: 15px;
  width: 533px;
  text-align: left;
}

.kuanjia {
  margin-top: 15px;
  width: 533px;
  text-align: left;
  margin-top: 20px;
  display: flex;
  gap: 50px;
  margin-bottom: 50px;
  justify-content: center;
  align-items: center;
}

.jianju1 {
  margin-top: 15px;
  width: 533px;
  text-align: left;
  display: flex;
  flex-direction: column;
}

.span {
  margin-right: 7px;
  width: 100px;
  display: inline-block;
  text-align: right;
  font-size: 19px;
}

.span1 {
  margin-right: 7px;
  width: 100px;
  display: flex;
  text-align: right;
  font-size: 19px;
  white-space: nowrap;
  flex-shrink: 0;
  justify-content: center;
}

.save {
  background-color: #3572e5;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.xiugai {
  margin-top: 42px;
}

.qvxiao {
  border: 3px solid #bfc3ce;
  color: #2e323d;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

@media (max-width: 768px) {
  .logo {
    width: 50px;
  }

  .head01 {
    display: flex;
    gap: 10px;
    padding-top: 140px;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .head02 {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .kuandu {
    width: 220px !important;
    margin-left: 10px;
  }

  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
  }

  .neirong {
    flex-direction: column;
    margin-left: 0;
    margin-top: 0px;
    padding: 0 15px;
  }

  .jianju {
    width: 100%;
    margin-top: 10px;
  }

  .jianju1 {
    margin-top: 15px;
    width: 100%;
  }

  .span,
  .span1 {
    width: 80px;
    font-size: 16px;
    text-align: left;
    margin-right: 10px;
  }

  .kuanjia {
    width: 100%;
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .xiugai {
    margin-top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .save,
  .qvxiao {
    width: 150px;
    height: 35px;
    font-size: 14px;
  }

  .el-date-editor.el-input__inner {
    width: 320px !important;
    margin-left: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/corpinfo.vue